// src/pages/Privacy.js
import React from "react";

const Section = ({ title, children }) => (
  <div className="policy-section">
    <h2 className="policy-section__title">{title}</h2>
    <div className="policy-section__body">{children}</div>
  </div>
);

const Privacy = () => (
  <div className="page">
    <div className="container static-page">
      <div className="static-hero">
        <span className="hero__badge">Legal</span>
        <h1 className="static-hero__title">Privacy <span className="hero__accent">Policy</span></h1>
        <p className="static-hero__sub">Last updated: {new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}</p>
      </div>

      <div className="policy-body">
        <Section title="1. Information We Collect">
          <p>When you create an account, we collect:</p>
          <ul>
            <li><strong>Email address</strong> — for authentication purposes</li>
            <li><strong>Display name</strong> — shown in your profile</li>
            <li><strong>Profile photo</strong> — only if you sign in with Google</li>
            <li><strong>Download history</strong> — list of photos you've downloaded</li>
          </ul>
          <p>We do <strong>not</strong> collect payment information, phone numbers, or physical addresses.</p>
        </Section>

        <Section title="2. How We Use Your Information">
          <p>We use your information to:</p>
          <ul>
            <li>Authenticate your account and keep it secure</li>
            <li>Save and display your download history</li>
            <li>Improve the website experience</li>
            <li>Respond to support requests</li>
          </ul>
        </Section>

        <Section title="3. Photos and Third-Party Content">
          <p>
            All photos on Halro Images are provided by <a href="https://www.pexels.com" target="_blank" rel="noopener noreferrer">Pexels</a>.
            When you search or browse photos, your request is sent through our server to the Pexels API.
            Pexels has its own <a href="https://www.pexels.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
          </p>
        </Section>

        <Section title="4. Cookies and Advertising">
          <p>
            We may display advertisements on our website. Ad networks such as Google AdSense
            may use cookies to show personalized ads based on your browsing history.
            You can opt out of personalized ads through <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">Google Ad Settings</a>.
          </p>
        </Section>

        <Section title="5. Data Storage">
          <p>
            Your account data is stored securely in <strong>Google Firebase (Firestore)</strong>,
            which is protected by Google's security infrastructure. We do not store your
            data on our own servers.
          </p>
        </Section>

        <Section title="6. Data Sharing">
          <p>We <strong>never sell</strong> your personal data. We only share data with:</p>
          <ul>
            <li><strong>Firebase/Google</strong> — for authentication and database storage</li>
            <li><strong>Pexels</strong> — your search queries to fetch photo results</li>
            <li><strong>Law enforcement</strong> — only if legally required</li>
          </ul>
        </Section>

        <Section title="7. Your Rights">
          <p>You have the right to:</p>
          <ul>
            <li>Access the personal data we hold about you</li>
            <li>Request deletion of your account and data</li>
            <li>Opt out of personalized advertising</li>
          </ul>
          <p>To exercise any of these rights, contact us at <a href="mailto:support@halro.online">support@halro.online</a></p>
        </Section>

        <Section title="8. Children's Privacy">
          <p>
            Halro Images is not intended for children under the age of 13.
            We do not knowingly collect data from children.
          </p>
        </Section>

        <Section title="9. Changes to This Policy">
          <p>
            We may update this Privacy Policy from time to time.
            Changes will be posted on this page with an updated date.
            Continued use of the website constitutes acceptance of the updated policy.
          </p>
        </Section>

        <Section title="10. Contact Us">
          <p>
            If you have any questions about this Privacy Policy, please contact us at:{" "}
            <a href="mailto:support@halro.online">support@halro.online</a>
          </p>
        </Section>
      </div>
    </div>
  </div>
);

export default Privacy;
